
import echarts from 'echarts'

//折线图柱状图混合
function pieEchart({ idName, colorArray, xyAxisArray, pieRadius, roseType, labelSet ,_this,sourceList}) {
    // 基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(document.getElementById(idName))

    // 指定图表的配置项和数据
    let option = {
        tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)"
        },

        color: colorArray,   //饼状图每个模块的颜色
        series: [
            {
                name: '',
                type: 'pie',
                radius: pieRadius,  //饼状图的外形
                avoidLabelOverlap: true,
                roseType: roseType,  //饼状图的类型
                label: labelSet,
                data: xyAxisArray
            }
        ]
    };
    //图表右击事件
     if(_this){
       let tempData = {sourceList:sourceList,xyAxisArray:xyAxisArray}
       echartsRightMenu(idName,myChart,tempData,_this);
     }
    //图表右击事件end

    // 使用指定的配置项和数据显示图表。
    myChart.setOption(option);
}
//图表右键事件
/**
 * @param  domID 表id
 * @param  chart 表对象
 * @param  _this this对象
 */
function echartsRightMenu(domID,chart,data,_this){
  let parent = document.getElementById(domID);
      let offsetBody = getPoint(parent);
      parent .oncontextmenu = () => false;
      chart.off('contextmenu');
      chart.on('contextmenu', function (params) {//右键事件
          params.event.event.preventDefault();
          _this.$refs.echartsRightMenu.styleMenu = {"left":(offsetBody.left + params.event.offsetX+15)+"px","top":(offsetBody.top + params.event.offsetY+15)+"px"}
          _this.$refs.echartsRightMenu.show = true;
          _this.$refs.echartsRightMenu.domID = domID;
          _this.$refs.echartsRightMenu.excelData = data;
  });
}
//获取某元素以浏览器左上角为原点的坐标
function getPoint(obj) {
    var t = obj.offsetTop; //获取该元素对应父容器的上边距
    var l = obj.offsetLeft; //对应父容器的上边距
    //判断是否有父容器，如果存在则累加其边距
    while (obj = obj.offsetParent) {//等效 obj = obj.offsetParent;while (obj != undefined)
        t += obj.offsetTop; //叠加父容器的上边距
        l += obj.offsetLeft; //叠加父容器的左边距
    }
    return {top:t,left:l};
}

export {
    pieEchart
}



// WEBPACK FOOTER //
// ./src/common/js/pieEchart.js